<template>
    <div>
        <a-modal v-model="viewModal" :closable="false" :maskClosable="false" title="Booking Informations">
            <a-card :style="{ backgroundColor: '#E9F8F9' }" :bordered="false">
                <a-row>
                    <a-col :span="24">
                        <p class="text-center mb-0 font-bold">
                            Booking Detail
                        </p>
                    </a-col>
                </a-row>
                <a-row class="mt-10 mb-10">
                    <a-col :span="6">
                        <p class="text-left mt-5 mb-0 font-bold">
                            Detail of Printing :
                        </p>
                    </a-col>
                    <a-col :span="18" :style="{ textAlign: 'center' }">
                        <p class="mt-5 mb-5">
                            {{ formData.detail_of_printing }}
                        </p>
                    </a-col>
                </a-row>
                <a-row class="mt-10 mb-10">
                    <a-col :span="6">
                        <p class="text-left mt-5 mb-0 font-bold">
                            Remark :
                        </p>
                    </a-col>
                    <a-col :span="18" :style="{ textAlign: 'center' }">
                        <p class="mt-5 mb-5">
                            {{ formData.remark }}
                        </p>
                    </a-col>
                </a-row>
                <a-row class="mt-10 mb-10">
                    <a-col :span="6">
                        <p class="text-left mt-5 mb-0 font-bold">
                            Requestor Name :
                        </p>
                    </a-col>
                    <a-col :span="18" :style="{ textAlign: 'center' }">
                        <p class="mt-5 mb-5">
                            {{ formData.requester_staff_detail.title.short_eng + ' ' +
                                formData.requester_staff_detail.name +
                                ' ' + formData.requester_staff_detail.surname }}
                        </p>
                    </a-col>
                </a-row>
                <a-row class="mt-10 mb-10">
                    <a-col :span="6">
                        <p class="text-left mt-5 mb-0 font-bold">
                            Time Service :
                        </p>
                    </a-col>
                    <a-col :span="18" :style="{ textAlign: 'center' }">
                        <p class="mt-5 mb-5">
                            {{ moment(formData.service_datetime_start).format("DD / MM / YYYY , HH:mm:ss") }}
                            -
                            {{ moment(formData.service_datetime_end).format("DD / MM / YYYY , HH:mm:ss") }}
                        </p>
                    </a-col>
                </a-row>
                <hr>
                <a-row class="mt-10 mb-10">
                    <a-col :span="24">
                        <p class="text-center mt-5 mb-0 font-bold">
                            Responsible staff
                        </p>
                    </a-col>
                </a-row>
                <div v-for="(data, index) in formData.staff_support_detail" :key="index + '_printing'">
                    <a-row class="mt-10 mb-10">
                        <a-col :span="6">
                            <p class="text-left mt-5 mb-0 font-bold">
                                Name :
                            </p>
                        </a-col>
                        <a-col :span="18">
                            <p class="mt-5 mb-5 text-center">
                                {{ data.staff_name }}
                            </p>
                        </a-col>
                    </a-row>
                    <a-row class="mt-10 mb-10">
                        <a-col :span="6">
                            <p class="text-left mt-5 mb-0 font-bold">
                                Tel :
                            </p>
                        </a-col>
                        <a-col :span="18" :style="{ textAlign: 'center' }">
                            <p class="mt-5 mb-5">
                                {{ data.telephone }}
                            </p>
                        </a-col>
                    </a-row>
                    <a-row class="mt-10 mb-10">
                        <a-col :span="6">
                            <p class="text-left mt-5 mb-0 font-bold">
                                Email :
                            </p>
                        </a-col>
                        <a-col :span="18" :style="{ textAlign: 'center' }">
                            <p class="mt-5 mb-5">
                                {{ data.email }}
                            </p>
                        </a-col>
                    </a-row>
                    <span v-if="formData.staff_support_detail.length > 1">
                        <hr>
                    </span>
                </div>
            </a-card>
            <a-card style="background-color:ghostwhite">
                <a-row class="mt-10 mb-10">
                    <a-col :span="6">
                        <p class="text-center mt-5 mb-0 font-bold">
                            Link assets file :
                        </p>
                    </a-col>
                    <a-col :span="18" :style="{ textAlign: 'left' }">
                        <p class="text-center mt-5 mb-5 ml-20">
                            <a :href="formData.link_url" target="_blank">{{ formData.link_url }}</a>
                        </p>
                    </a-col>
                </a-row>
                <a-row class="mt-10 mb-10">
                    <a-col :span="6">
                        <p class="text-center mt-5 mb-0 font-bold">
                            Staff remark :
                        </p>
                    </a-col>
                    <a-col :span="18" :style="{ textAlign: 'left' }">
                        <p class="text-center mt-5 mb-5 ml-20">
                            {{ formData.text_to_user }}
                        </p>
                    </a-col>
                </a-row>
            </a-card>

            <template slot="footer">
                <a-button key="back" @click="onCloseModal()"> Close pop-up </a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
export default {
    props:
    {
        dataInformation: {
            type: Object
        },
        viewModal: {
            type: Boolean,
            default: false,
        },
        onCloseModal: {
            type: Function
        },
        updateTableData: {
            type: Function,
        },
    },
    mounted() {
        this.isRatedUs = this.formData.vote_score ? true : ''
    },
    computed: {
        isdataInformation() {
            if (
                this.formData.vote_score
            ) {
                return true;
            } else {
                return false;
            }
        },
    },
    components: {
    },
    methods: {
        async onCreateEvaluationData() {
            this.isLoaded = false;
            this.isRatedUs = false
            this.$http.post(
                `/booking/photo/${this.formData.id}/evaluation/`,
                {
                    "vote_score": this.formData.vote_score,
                    "comment": this.formData.comment
                }
            ).then(
                (res) => {
                    if (res.status === 200) {
                        let updateData = res.data
                        let idRecordTable = this.formData.idRecordTable
                        this.$emit('updateTableData', { updateData, idRecordTable })
                        this.isLoaded = true;
                        this.isRatedUs = true
                    } else {
                        const error = new Error('Request Failed');
                        error.res = res;
                        error.response = res;
                        throw error;
                    }
                },
                (error) => {
                    this.isLoaded = true;
                    this.$notification['error']({
                        message: function (h) {
                            return h("div", [
                                h("strong", { class: "" }, `Failed to connect to the API`),
                            ]);
                        },
                        description:
                            `Error ${error.response.status} : /booking/photo/{id}/evaluation/`,
                    });
                })
        }
    },
    data() {
        return {
            isLoaded: true,
            isRatedUs: false,
            formData: JSON.parse(JSON.stringify(this.dataInformation)),// Object.assign({}, this.dataEngagement),
        };
    }
}
</script>